import React, { useEffect } from 'react';
import NavbarComp from '../Components/NavbarComp';
import { AiOutlineArrowRight } from 'react-icons/ai'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Services from './Services';
import Contact from './Contact';
import Footer from './Footer';
const icon2 = require('../img/iconPill.png')
const icon3 = require('../img/iconstethescope.png')

export default function Home() {
    useEffect(()=>{
        window.scrollTo(0,0)
    },[])
	return (
		<div>
			<NavbarComp />
			<Row className='row mt-5 banner' style={{ width: '100%' }} id='home'>
				<Col lg={6} md={6} sm={6} xs={12}>
					<div className='banner-text'>
						<span className='banner-pro-1'>Life</span> and <span className='banner-pro-1'>health</span> is not a choice, it's 
                        your <span className='banner-pro'>priority</span>
                        <div className="banner-intro-btn">
                        <a href="#contact" style={{textDecoration: 'none'}}>Book An Appointment <AiOutlineArrowRight /></a>
                    </div>
					</div>
                    
				</Col>
				<Col lg={6} md={6} sm={6} xs={12} className='ban-img-con'>
					<img src={require('../img/banner.png')} alt='' className='banner-img'/>
				</Col>
			</Row>
            <div className="intro">
                <div className="intro-block">
                    <img src={icon2} alt="" />
                    <h3>Medical Treatment</h3>
                    <hr className='hr'/>
                    <p>Management and care of a patient to combat disease or disorder.</p>
                    <div className="intro-btn">
                        <a href="#contact" style={{textDecoration: 'none'}}>Appointment <AiOutlineArrowRight /></a>
                    </div>
                </div>
                <div className="intro-block">
                    <img src={icon3} alt="" />
                    <h3>Regular Examination</h3>
                    <hr className='hr'/>
                    <p>Make online appointments for regular health examinations.</p>
                    <div className="intro-btn">
                        <a href="#contact" style={{textDecoration: 'none'}}>Appointment <AiOutlineArrowRight /></a>
                    </div>
                </div>
		    </div>
            <div className="parallax-I"></div>
            <div className="para-text-I">
                <p>Eat better, not less!</p>
            </div>
            <div className="parallax1-I"></div>
            <Services />
            <div className="parallax-II"></div>
            <div className="para-text-II">
                <p>Make your health your priority</p>
            </div>
            <div className="parallax1-II"></div>
            <Contact />
            <Footer />
		</div>
	);
}
